import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import Vue from 'vue';
import { getAll as getAllProduitEcranNumerique } from '@/api/produit/produitNumerique';
import { getAll as getAllProduitReseauNumerique } from '@/api/produit/produitReseauNumerique';
import { getAllPlanning } from '@/api/dispo/index';
import {
  periodeHelper, PeriodeDejaPresente, preparationSuppressionDate, deletePeriode,
} from '@/services/catalogue/planning/periodeHelper';
import transform from '@/services/catalogue/filters/produitServerTableDataTransformer';
import getLogo from '@/services/general/getLogo';
import { getAffectationEcranNumerique } from '@/api/affectation/index';
import selectionPeriodeBrief from '@/services/devisCommandes/selectionPeriodeBrief';
import calculTarifDansLePanier from '@/services/devisCommandes/tarifDansLePanier';
import formatIsoDate from '@/services/general/formatIsoDate';
import { CATEGORIE_REGROUPEMENT_NUMERIQUE } from '@/configuration/catalogue/produitConf';
import { SOUS_TYPE_AVOIR, SOUS_TYPE_AVOIR_SUR_ACOMPTE } from '@/configuration/devisConf';
import getPiecesJointeLogoByIds from '@/services/piecesJointes/getPiecesJointeLogoByIds';
import genererCritereRechercheProduitEcran from '@/services/catalogue/genererCriteresRecherche/genererCritereRechercheProduitEcranNumerique';
import * as allTypes from '../mutation-type';
import * as types from './produitEcranNumerique-mutation-type';

export function initialState(isCartographie = false) {
  return {
    produits: [],
    totalProduits: 0,
    isUpdate: true,
    typeProduit: null,
    criterePlanning: {
      dateStart: moment([2019, 0, 1]),
      dateEnd: moment([2019, 0, 31]),
      days: 31,
    },
    // Les dates des périodes à l'intérieur du panier sont des chaines au format ISO8601
    panier: {},
    regroupementPersonnalise: true,
    brief: {
      datesDebut: null, // n'est jamais utilisé
      datesFin: null,
      saturation: null,
      produitLocationNum: null,
      daySelected: [],
      budgetMax: null,
      toggleSelectionPlanning: false,
    },
    criteresRecherche: genererCritereRechercheProduitEcran(isCartographie),
    lastPayload: {},
  };
}

const specAffichage = {
  widescreen: {
    size: 31,
  },
  tablet: {
    size: 18,
  },
};

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_PRODUITS](state, produits) {
    state.produits = produits;
  },
  [types.SET_IS_VIEW_UPDATE](state, isUpdate) {
    state.isUpdate = isUpdate;
  },
  [types.TOGGLE_SELECTION_PLANNING](state) {
    state.brief.toggleSelectionPlanning = !state.brief.toggleSelectionPlanning;
  },
  [types.SET_BRIEF](state, brief) {
    state.brief = brief;
  },
  [types.CLEAR_BRIEF](state) {
    state.brief = initialState().brief;
  },
  [types.SET_TOTAL_PRODUITS](state, totalProduits) {
    state.totalProduits = totalProduits;
  },
  [types.SET_CRITERE_PLANNING](state, criterePlanning) {
    state.criterePlanning = criterePlanning;
  },
  [types.SET_PERIODE_OF_PRODUCT](state, produit) {
    state.panier[produit.produitId].periode = produit.periode;
  },
  [types.SET_REGROUPEMENT_PERSONNALISE](state, regroupementPersonnalise) {
    state.regroupementPersonnalise = regroupementPersonnalise;
  },
  [types.SET_LAST_PAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
  [types.CLEAR_PANIER](state) {
    state.panier = {};
  },
  [types.ADD_PANIER](state, item) {
    Vue.set(state.panier, item.produitId, item);
  },
  [types.ADD_PERIOD](state, item) {
    const produitFocus = state.panier[item.produitId];
    const dates = {
      dateDebut: item.periode[0].dateDebut,
      dateFin: item.periode[0].dateFin,
      prix: item.periode[0].prix,
      produitLocationNum: item.periode[0].produitLocationNum,
      saturation: state.brief.saturation,
    };
    const isAgrandissementPeriodeExistante = periodeHelper(item.periode[0], produitFocus.periode);
    if (isAgrandissementPeriodeExistante === false) {
      produitFocus.periode.push(dates);
    }
  },
  [types.DELETE_PERIOD](state, item) {
    const produitFocus = state.panier[item.produitId];
    deletePeriode(produitFocus.periode, item.periode[0], item.index);
    if (produitFocus.periode.length === 0) {
      delete state.panier[item.produitId];
    }
  },
  [types.SET_TYPE_PRODUITS](state, item) {
    state.typeProduit = item;
  },
  [types.SET_LOGO](state, item) {
    const produitFocus = state.panier[item.produitId];
    produitFocus.logo = item.logo;
  },
  [types.SET_CRITERES_RECHERCHE](state, criteresRecherche) {
    state.criteresRecherche = criteresRecherche;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async calculTarifPanier({ getters, rootState }) {
    await calculTarifDansLePanier(getters.panier, state.typeProduit);
    if (rootState?.commande?.commande?.sousType === SOUS_TYPE_AVOIR
      || rootState?.commande?.commande?.sousType === SOUS_TYPE_AVOIR_SUR_ACOMPTE
    ) {
      Object.values(getters.panier).forEach(produit => {
        produit.periode.forEach(p => {
          if (p.prix > 0) p.prix *= -1;
        });
      });
    }
  },
  async loadProduits({ commit, dispatch, getters }, data) {
    let response = null;
    if (getters.typeProduits === CATEGORIE_REGROUPEMENT_NUMERIQUE) {
      response = await getAllProduitReseauNumerique(data);
    } else {
      response = await getAllProduitEcranNumerique(data);
    }
    commit(types.SET_TOTAL_PRODUITS, response.data.result.totalCount);
    if (getters.criterePlanning.dateEnd && getters.criterePlanning.dateStart) {
      await dispatch('updateWithDisponibilities', response.data.result.items);
    } else {
      commit(types.SET_PRODUITS, response.data.result.items);
    }
    return {};
  },
  async loadProduitsEcran({ commit }, data) {
    const response = await getAllProduitEcranNumerique(data);
    const produits = response.data.result.items;
    const allIds = produits.map(p => p.id);
    if (allIds.length > 0) {
      const paramsAffectation = [];
      produits.forEach((el) => {
        el.selected = false;
        el.affectations = [];
        paramsAffectation.push({
          id: el.id,
          dureeAffectation: {
            dateDebut: formatIsoDate(data.query.dureeAffectation.dateDebut),
            dateFin: formatIsoDate(data.query.dureeAffectation.dateFin),
          },
        });
      });
      const resultAffectation = (await getAffectationEcranNumerique(paramsAffectation))
        .data
        .result;
      produits.forEach((item) => {
        if (!resultAffectation[item.id]) return;
        item.affectations = resultAffectation[item.id];
        item.affectations = item.affectations.sort((a, b) => {
          const dateA = new Date(a.dureeAffectation.dateDebut);
          const dateB = new Date(b.dureeAffectation.dateDebut);
          return dateA - dateB;
        });
      });
    }
    if (!data.withoutImage) {
      await getPiecesJointeLogoByIds(response.data.result.items, 'produitEcranNumerique.materielId');
    }
    commit(types.SET_LAST_PAYLOAD, transform(data));
    commit(types.SET_PRODUITS, produits);
    commit(types.SET_TOTAL_PRODUITS, response.data.result.totalCount);
    return {};
  },
  selectionLigne({ commit, getters }, produitId) {
    const arrayDates = selectionPeriodeBrief(
      { dateDebut: getters.brief.dateDebut, dateFin: getters.brief.dateFin },
      getters.brief.daySelected.filter((el) => { return el.selected === true; }),
      getters.brief.produitLocationNum,
    );
    if (arrayDates.length === 0) {
      return;
    }
    const productInPannier = getters.panier[produitId];
    let periodes = [];
    if (productInPannier) {
      periodes = cloneDeep(productInPannier.periode);
    }

    for (let p = 0; p < arrayDates.length; p += 1) {
      const periode = {
        prix: null,
        dateDebut: arrayDates[p],
        dateFin: arrayDates[p],
        produitLocationNum: getters.brief.produitLocationNum,
        saturation: getters.brief.saturation,
      };
      const periodCheck = PeriodeDejaPresente(periode, periodes);
      let suppression = false;
      if (periodCheck && periodCheck.produitLocationNum.id !== periode.produitLocationNum.id) {
        const index = preparationSuppressionDate(periodes, periode);
        deletePeriode(periodes, periode, index);
        suppression = true;
      }
      if (!periodCheck || suppression) {
        // Si la période n'existe pas déjà ou qu'elle a été supprimée (produit de loc différent)
        // Il faut l'ajouter
        const isAgrandissementPeriodeExistante = periodeHelper(periode, periodes);
        if (isAgrandissementPeriodeExistante === false) {
          periodes.push(periode);
        }
      }
    }

    if (productInPannier) {
      commit(types.SET_PERIODE_OF_PRODUCT, { produitId: produitId, periode: periodes });
    } else {
      const newProduct = {
        produitId: produitId,
        typeProduit: getters.typeProduits,
        logo: null,
        reference: getters.produits.find((el) => { return el.id === produitId; }).libelle,
        periode: periodes,
      };
      commit(types.ADD_PANIER, newProduct);
    }
  },
  changeCriterePlanning({ commit, getters }, data) {
    let breakpoint = 'tablet';
    if (window.innerWidth >= 1550) {
      breakpoint = 'widescreen';
    }
    data.days = specAffichage[breakpoint].size;
    data.dateEnd = data.dateStart.clone().add(data.days, 'd');
    if (getters.criterePlanning.dateStart.isSame(data.dateStart, 'day')
      && getters.criterePlanning.dateEnd.isSame(data.dateEnd, 'day')
      && getters.criterePlanning.days === data.days) {
      // Optimisation uniquement
      return;
    }
    commit(types.SET_CRITERE_PLANNING, data);
  },
  async updateWithDisponibilities({ commit, getters }, data) {
    const produits = data;
    const allIds = produits.map(p => p.id);
    if (allIds.length === 0) {
      commit(types.SET_PRODUITS, produits);
      return;
    }
    const response = await getAllPlanning(
      allIds, getters.criterePlanning.dateStart, getters.criterePlanning.dateEnd,
    );
    produits.forEach(p => {
      if (Object.prototype.hasOwnProperty.call(p, 'dispo')) {
        p.dispo.splice(0, p.dispo.length);
        p.dispo.push(...response.data.result[p.id]);
      } else {
        p.dispo = response.data.result[p.id];
      }
    });
    commit(types.SET_PRODUITS, produits);
  },
  updatePanier({ commit, getters }, data) {
    const produitIdIdentique = getters.panier[data.produitId];
    const venteNum = {
      produitId: data.produitId,
      typeProduit: data.typeProduit,
      logo: null,
      reference: data.libelleProduit,
      // n'est appellé qu'avec dateDebut/dateFin égales
      periode: [{
        prix: null,
        dateDebut: moment(data.date),
        dateFin: moment(data.date),
        produitLocationNum: data.produitLocationNum,
        saturation: getters.brief.saturation,
      }],
    };
    if (!produitIdIdentique) commit(types.ADD_PANIER, venteNum);
    else {
      const periodCheck = PeriodeDejaPresente(venteNum.periode[0], produitIdIdentique.periode);
      if (periodCheck) {
        const index = preparationSuppressionDate(produitIdIdentique.periode, venteNum.periode[0]);
        venteNum.index = index;
        commit(types.DELETE_PERIOD, venteNum);
        if (periodCheck.produitLocationNum.id !== venteNum.periode[0].produitLocationNum.id) {
          const encoreProduitIdIdentique = getters.panier[data.produitId];
          if (!encoreProduitIdIdentique) {
            commit(types.ADD_PANIER, venteNum);
          } else {
            commit(types.ADD_PERIOD, venteNum);
          }
        }
      } else {
        commit(types.ADD_PERIOD, venteNum);
      }
    }
  },
  updatePanierSansSuppression({ commit, getters }, data) {
    const produitIdIdentique = getters.panier[data.produitId];
    const venteNum = {
      produitId: data.produitId,
      typeProduit: data.typeProduit,
      logo: null,
      reference: data.libelleProduit,
      // n'est appellé qu'avec dateDebut/dateFin égales
      periode: [{
        prix: null,
        dateDebut: moment(data.date),
        dateFin: moment(data.date),
        produitLocationNum: data.produitLocationNum,
        saturation: getters.brief.saturation,
      }],
    };
    if (!produitIdIdentique) {
      commit(types.ADD_PANIER, venteNum);
    } else {
      const periodCheck = PeriodeDejaPresente(venteNum.periode[0], produitIdIdentique.periode);
      if (periodCheck
        && periodCheck.produitLocationNum.id !== venteNum.periode[0].produitLocationNum.id) {
        const index = preparationSuppressionDate(produitIdIdentique.periode, venteNum.periode[0]);
        venteNum.index = index;
        commit(types.DELETE_PERIOD, venteNum);
        const encoreProduitIdIdentique = getters.panier[data.produitId];
        if (!encoreProduitIdIdentique) {
          commit(types.ADD_PANIER, venteNum);
        } else {
          commit(types.ADD_PERIOD, venteNum);
        }
      }
      if (!periodCheck) {
        commit(types.ADD_PERIOD, venteNum);
      }
    }
  },
  loadLogoPanier({ commit, getters }) {
    Object.values(getters.panier).forEach(async (produit) => {
      if (!getters.logoProduitSelectionne(produit.produitId)) {
        const logo = {
          produitId: produit.produitId,
          logo: await getLogo(produit.produitId),
        };
        commit(types.SET_LOGO, logo);
      }
    });
  },
};

const getters = {
  produits: state => {
    return state.produits;
  },
  criterePlanning: state => {
    return state.criterePlanning;
  },
  totalProduits: state => {
    return state.totalProduits;
  },
  typeProduits: state => {
    return state.typeProduit;
  },
  panier: state => {
    return state.panier;
  },
  brief: state => {
    return state.brief;
  },
  regroupementPersonnalise: state => {
    return state.regroupementPersonnalise;
  },
  produitLibelle: state => payload => {
    const produit = state.produits.find((el) => el.id === payload);
    return produit.libelle;
  },
  logoProduitSelectionne: state => payload => {
    const produit = state.panier[payload];
    if (produit.logo) return true;
    return false;
  },
  produitSelectionne: state => payload => {
    const produit = state.panier[payload];
    return !!produit; // Pour forcer le retour en booleen
  },
  isUpdate: state => {
    return state.isUpdate;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
